;(function() {
  'use strict'

  angular.module('core.gSwitch', [])
})()
